@if (isVisible()) {
  <p-breadcrumb
    ngSkipHydration
    class="block max-w-full page-breadcrumbs"
    [model]="items()"
    (onItemClick)="onItemClick($event)"
    id="breadcrumbs">
    <ng-template pTemplate="item" let-item>
      @if (item.dataTestId) {
        <div [attr.data-test-id]="item.dataTestId">
          {{ item.label }}
        </div>
      } @else {
        <div>
          {{ item.label }}
        </div>
      }
    </ng-template>
    <ng-template pTemplate="separator">
      <span>{{ separator() }}</span>
    </ng-template>
  </p-breadcrumb>
}
